//引入vue核心库
import Vue from "vue"
//引入Vuex
import Vuex from "vuex"
//应用Vuex插件
Vue.use(Vuex)

import user from "./user"

export default new Vuex.Store({
    modules: {
        user,
    }
})

